import { Component, Prop, ProvideReactive, Vue } from "vue-property-decorator";
import MagicChildrenBlock from "./MagicChildrenBlock.vue";

@Component({
  name: "RuntimeChildrenRow",
  components: { MagicChildrenBlock }
})
export default class RuntimeChildrenRow extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  private origin!: any;

  @Prop({
    type: Array,
    default: []
  })
  private widgets!: App.WebForm.Widget[];

  @Prop({
    type: String,
    default: ""
  })
  @ProvideReactive("loop")
  private loop!: string;

  @Prop({
    type: String,
    default: ""
  })
  private tableProperties!: any;

  @Prop({
    type: String,
    default: ""
  })
  @ProvideReactive("tableName")
  private tableName!: string;

  @Prop({
    type: String,
    default: ""
  })
  private tableId!: any;

  @Prop({
    type: Object,
    default: {}
  })
  private config!: {
    isHtml: boolean;
    model: any;
    options: {
      widgets: App.WebForm.Widget[];
    };
  };

  @Prop({
    type: Number
  })
  @ProvideReactive("row")
  private row!: number;

  render(createElement: any) {
    if (this.origin) {
      const template = decodeURIComponent(this.origin);
      const compiler = Vue.compile(template);
      this.$options.staticRenderFns = compiler.staticRenderFns;
      return compiler.render.call(this, createElement);
    } else {
      return createElement(this.$slots.default);
    }
  }
}

